import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const EmailBroadcastsPage = lazy(() => import('@/pages/emails/broadcasts'));

export const Route = createFileRoute('/emails/broadcasts')({
  component: function EmailBroadcastsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <EmailBroadcastsPage />
      </Suspense>
    );
  },
});
